import { StyledGradient } from './styles';

export default StyledGradient;
